import React, { useEffect, useRef } from 'react';

const TITLE_ID = 'demo-acknowledge-title';
const MESSAGE_ID = 'demo-acknowledge-message';

export default function AcknowledgeModal({ title, message, icon = null, confirmLabel = __('OK'), onConfirm }) {
    const confirmRef = useRef(null);

    useEffect(() => {
        confirmRef.current?.focus();
    }, []);

    const handleKeyDown = (event) => {
        if (event.key === 'Tab' || event.key === 'Escape') {
            event.preventDefault();
            confirmRef.current?.focus();
        }
    };

    // The page behind the overlay stays focusable in the DOM, so a click or a
    // programmatic focus outside the dialog is pulled back to the only control.
    const handleBlur = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            confirmRef.current?.focus();
        }
    };

    return (
        <>
            <div className="modal-backdrop show" data-testid="demo-ack-backdrop" />
            <div
                role="alertdialog"
                aria-modal="true"
                aria-labelledby={TITLE_ID}
                aria-describedby={MESSAGE_ID}
                className="modal d-block"
                tabIndex="-1"
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                {icon && <span aria-hidden="true" className="mr-2">{icon}</span>}
                                <span id={TITLE_ID}>{title}</span>
                            </h4>
                        </div>
                        <div className="modal-body">
                            <p className="mb-0" id={MESSAGE_ID}>{message}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" ref={confirmRef} onClick={onConfirm}>
                                {confirmLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
